import axios from 'axios'
import { getToken } from './auth'

const api = axios.create({
  baseURL: process.env.REACT_APP_ORCH_DOCS_HOST,
})

api.interceptors.request.use(async (config) => {
  const token = getToken()
  const newConfig = config

  if (token) {
    newConfig.headers.Authorization = token
  }

  const apiKey = process.env.REACT_APP_ORCH_DOCS_KEY
  if (apiKey) {
    newConfig.headers['x-api-key'] = apiKey
  }

  return newConfig
})

const reqMsType = () => api.get('/mstype')

const listAsyncService = async (query = null) => {
  let urlFilters = ''

  if (query !== null) {
    urlFilters = query
  }

  return api.get(`/services/async${urlFilters}`)
}

const listDirectService = async (query = null) => {
  let urlFilters = ''

  if (query !== null) {
    urlFilters = query
  }

  return api.get(`/services/direct${urlFilters}`)
}

const getDocAsyncApi = serviceId => api.get(`/services/async/doc?service_id=${serviceId}`)

const getDocDirectApi = serviceId => api.get(`/services/direct/doc?service_id=${serviceId}`)

export default api
export {
  getDocAsyncApi,
  getDocDirectApi,
  listDirectService,
  listAsyncService,
  reqMsType,
}
